import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { INDUSTRIES_WITH_CPD_CATEGORYS_ENDPOINT } from './endpoints';

const actions = createActions({
  INDUSTRIES: {
    INDUSTRIES_WITH_CPD_CATEGORYS: () => ({}),
    API: {
      INDUSTRIES_WITH_CPD_CATEGORYS: apiResourceActionCreator('industriesWithCpdCategorys')
    }
  }
})

export const apiAction = () => commonApiActions.get(INDUSTRIES_WITH_CPD_CATEGORYS_ENDPOINT, actions.industries.api.industriesWithCpdCategorys)

export function* fetchIndustriesWithCpdCategorys(action) {
  yield put(apiAction());
}

const configuration = {
  name: 'industriesWithCpdCategorys',
  action: actions,
  sagas: fetchIndustriesWithCpdCategorys,
  reducers: {
    request: (state, action) => {
      return Object.assign({}, state, {
        isFetchingIndustries: true,
        industriesWithCpdCategorys: []
      });
    },
    success: (state, action) => {
      return Object.assign({}, state, {
        isFetchingIndustries: false,
        industriesWithCpdCategorys: action.payload.industriesWithCpdCategorys
      });
    },
    failed: (state, action) => {
      return Object.assign({}, state, {
        isFetchingIndustries: false,
        error: action.payload.error
      });
    },
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/industry/configurations/industriesWithCpdCategorys.js